/**
 * Converts a string into a lowercase, URL-friendly slug.
 * 
 */
export function slugify(text: string): string {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters (letters, numbers, and dashes)
        .replace(/\-\-+/g, "-"); // Replace multiple dashes with a single dash
}
